// extracted by mini-css-extract-plugin
export default {"section":"OnIccFZP2p","description":"ZaLxFD36Pf","examples":"UoV6M_asgw","example":"uQFvgesPNd","image":"wJ3CLpRZCs","exampleTitle":"nGV9ZpjlHk"};